import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Card,
  Divider,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from '@material-ui/core';
import { getQuoteProductSubscriptionOptionsApi } from 'api';
import { useStyles } from '../styles';
import QuoteAutomationItemsTableRow from './QuoteAutomationItemsTableRow';


const QuoteAutomationItemsTable = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { subscriptionOptionsBySku } = useSelector((state: IReduxState) => state.quote);
  const { autoQuoteItems } = useSelector((state: IReduxState) => state.automatedQuotes);

  useEffect(() => {
    if (autoQuoteItems?.length) {
      autoQuoteItems?.map((item) => {
        const {sku} = item;

        if (!subscriptionOptionsBySku?.[sku] && sku) {
          getQuoteProductSubscriptionOptionsApi({ dispatch, sku });
        }
      });
    }
  }, [autoQuoteItems]);

  return (
    <Card>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography variant="h5" gutterBottom className="ml-2">
          Selected Quote Items ({autoQuoteItems?.length})
        </Typography>
      </Box>
      <Divider />
      <TableContainer>
        <Table className={classes.selectedItemsTable}>
          <TableBody className={classes.quoteSummaryTable}>
            {autoQuoteItems?.map((item, id) => (
              <QuoteAutomationItemsTableRow
                key={`${id}-${item.sku}`}
                item={item}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default QuoteAutomationItemsTable;
